<template>
    <section class="h-screen w-full flex-center flex-col gap-6 lg:gap-8 rtl">
        <div class="flex-center ">

            <div class="w-24  h-24 lg:w-40 lg:h-40 flex-center rounded-full bg-blue-600  text-white text-4xl lg:text-7xl font-bold">4</div>

            <div class="relative w-20 h-32 lg:w-36 lg:h-48 shadow shadow-md shadow-sky-500 overflow-hidden bg-white -skew-x-[40deg] flex-center hover:shadow hover:shadow-sm hover:shadow-green-500 group transition-all">

                <div class="absolute top-1/2 left-1/2 -translate-x-1/2  -translate-y-1/2 w-24 h-24 lg:w-40 lg:h-40 flex-center rounded-full bg-blue-600 text-white text-4xl lg:text-7xl font-bold skew-x-[40deg] group-hover:scale-105 transition-transform">0</div>

            </div>

            <div class="w-24 h-24 lg:w-40 lg:h-40 flex-center rounded-full bg-blue-600 text-white text-4xl lg:text-7xl font-bold">4</div>
             </div>
        <p class="text-xl text-xl font-bold font-IRANSans lg:text-2xl text-gray-500">صفحه مورد نظر یافت نشد.</p>
        <router-link :to="{ name: 'home' }"  class="public-text rounded-lg bg-blue-600 text-white shadow shadow-md shadow-sky-500 Hover:shadow hover:shadow-sm hover:shadow-green hover:text-gray-100 px-4 py-2 transition-all">رفتن به صفحه اصلی</router-link>
         
    </section>
   
  </template>
  <script setup>
  import {onMounted} from 'vue'
  import { useHead } from "@vueuse/head";
  import { useRoute } from 'vue-router';
  const route=useRoute()
  onMounted(() => {
   useHead({
    link:[
  {
    rel: "canonical",
      href: "https://parsinekala.com"+route.path.replace(/\/$/, ''),
  }]
   })
  
  });
  </script>
  <style scoped lang="scss">
  @mixin flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @mixin circle {
    width: 14rem;
    height: 14rem;
    border-radius: 50%;
    background-color: rgb(0, 64, 255);
    font-size: 10rem;
    font-weight: 700;
    color: white;
    @media only screen and (max-width: 599.98px) {
      width: 7rem;
      height: 7rem;
      font-size: 4rem;
      font-weight: 700;
    }
  }
  .content {
    @include flex-center();
    height: 100%;
    position: relative;
    .circle {
      @include flex-center();
      @include circle();
    }
    .margin {
      margin-left: 10rem;
      @media only screen and (max-width: 599.98px) {
        margin-left: 7rem;
      }
    }
    .rect {
      position: absolute;
      width: 14rem;
      height: 18rem;
      top: 50%;
      transform: translateY(-50%) skewX(-40deg);
      background-color: rgb(244, 241, 241);
      box-shadow: 0 0 5px rgb(146, 143, 143);
      @include flex-center();
      overflow: hidden;
      @media only screen and (max-width: 599.98px) {
        width: 7rem;
        height: 11rem;
      }
  
      .circle2 {
        transform: skewX(400deg);
        @include circle();
        @include flex-center();
      }
    }
    .text {
      position: absolute;
      bottom: 8rem;
      font-family: iranyekan;
      font-size: 2rem;
      font-weight: bold;
      color: var(--color-n-3);
      @media only screen and (max-width: 599.98px) {
        font-size: 1rem;
        bottom: 12rem;
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 4rem;
    @media only screen and (max-width: 599.98px) {
      bottom: 8rem;
    }
  }
  </style>
  